import { useRouteNamespaces } from '@aikoa/i18n/react'
import { Slot } from 'expo-router'
import { View } from 'react-native'
import AppHeader from '~/components/AppHeader'
import {
  PublicPreviewProvider,
  usePublicPreviewAuth,
} from '~/components/auth/PublicPreviewProvider'

export default function PublicPreviewLayout() {
  useRouteNamespaces('(authenticated)')

  return (
    <PublicPreviewProvider>
      <PublicPreviewContent />
    </PublicPreviewProvider>
  )
}

function PublicPreviewContent() {
  const { isInPublicPreview } = usePublicPreviewAuth()

  return (
    <View className="my-2 flex-1">
      <AppHeader
        showMenuButton={!isInPublicPreview}
        showBackButton={!isInPublicPreview}
        showLoginButton={!isInPublicPreview}
        logoIsLink={!isInPublicPreview}
      />
      <Slot />
    </View>
  )
}
